import { Vue } from 'vue-property-decorator';

Vue.directive('title', {
    inserted: (el, binding) => (document.title = `Beehive - ${binding.value}`),
    update: (el, binding) => (document.title = `Beehive - ${binding.value}`)
});
